export default {
  dialog: {
    title: "Download Evidence",
  },
  common: {
    loading: "Loading...",
    download: "Download",
    empty: "No Data",
  },
  columns: {
    fileName: "File Name",
    uploader: "Uploader",
    uploadTime: "Upload Time",
  },
};
